import { Button } from "@mui/material";
import {
  SearchBar,
  Dropdown,
  Modal,
  Pagination as DynamicPagination,
  Icon,
} from "@components/index";
import AddClientForm from "./components/AddClientForm";
import ClientListRender from "./components/ClientListRender";
import {
  searchOptions,
  clientStatusOptions,
  useClientManagementData,
} from "./clientManagementData";
import "./index.scss";

const ClientManagement = () => {
  const {
    openAddNewClientModal,
    handleAddNewClient,
    handleEditClient,
    handleCloseModal,
    editingClient,
    currentClientList,
    allClientList,
    filters,
    handleFilterChange,
    handleClearFilters,
    currentPage,
    handlePageChange,
    loading,
    error,
  } = useClientManagementData();

  const handleSearchChange = (_, searchValue) => {
    handleFilterChange({ ...filters, searchValue });
  };

  const handleStatusChange = (status) => {
    handleFilterChange({ ...filters, status });
  };

  return (
    <div className="client-management-page">
      <div
        className="client-management-page__header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h1 className="client-management-page__title">Client Management</h1>
          <p className="client-management-page__subtitle">
            Manage client accounts and information
          </p>
        </div>
        <Button
          variant="contained"
          size="large"
          className="client-management-page__add-btn"
          onClick={handleAddNewClient}
        >
          <Icon
            iconName="addUser"
            height={16}
            width={16}
            className="add-user-icon"
          />
          Add New Client
        </Button>
      </div>

      <div className="client-management-page_filters">
        <div className="client-management-page_filters-section">
          <SearchBar
            searchOptions={searchOptions}
            onSearch={handleSearchChange}
            showSearchButton={false}
            initialValue={filters.searchValue}
          />

          <Dropdown
            label="Client Status"
            value={filters.status}
            onChange={handleStatusChange}
            options={clientStatusOptions}
            className="client-management-page_status-dropdown"
          />
        </div>

        <button
          className="client-management-page_clear-btn"
          onClick={handleClearFilters}
        >
          Reset Filters
        </button>
      </div>

      {/* Clients List */}
      <ClientListRender
        clientList={currentClientList}
        loading={loading}
        error={error}
        onClearFilters={handleClearFilters}
        onEditClient={handleEditClient}
      />

      {/* Pagination */}
      <DynamicPagination
        data={allClientList}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        itemsPerPage={10}
        showInfo={true}
        showFirstButton={true}
        showLastButton={true}
      />

      {/* Add/Edit Client Modal */}
      <Modal
        isOpen={openAddNewClientModal}
        onClose={handleCloseModal}
        className="my-custom-modal"
        closeOnOutsideClick={false}
      >
        <AddClientForm
          onCancel={handleCloseModal}
          clientData={editingClient}
          onClearFilters={handleClearFilters}
        />
      </Modal>
    </div>
  );
};

export default ClientManagement;
